import Home from './Home/Home.page';
import AdvancedSearch from './AdvancedSearch/AdvancedSearch.page';
import AddProperty from './AddProperty/AddProperty.page';
import AdvisorProfile from './AdvisorProfile/AdvisorProfile.page';
import SimplePage from './SimplePage/SimplePage.page';
import NotFound from './NotFound/NotFound.page';

export {
  Home,
  AdvancedSearch,
  AddProperty,
  AdvisorProfile,
  SimplePage,
  NotFound
}
